import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import { WEBBACK_V2_API } from "@constants";
import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import {marketplacesOffersDetailsIsEmpty} from "../@signals";


export default function useMarketplacesOffersDetailsFilters() {

    const tableData = useSignal([])
    const isLoading = useSignal(false)

    useEffect(() => {
        if (isLoadingCommonFilters.value) {
            tableData.value = []
            isLoading.value = true
            postSubmit(`${WEBBACK_V2_API}/marketplaces/offers-details/context`, { ...commonFiltersValue.peek() })
                .then(res => {
                    if (!res?.length)
                        marketplacesOffersDetailsIsEmpty.value = true
                    tableData.value = res
                    isLoading.value = false
                    isLoadingCommonFilters.value = false
                })
                .catch(() => {
                    isLoading.value = false
                    isSystemBusy.value = true
                    isLoadingCommonFilters.value = false
                })
        }
    }, [isLoadingCommonFilters.value])


    return {
        tableData: tableData.value,
        isLoading: isLoading.value
    }
}